import { useBrand } from "../context/BrandContext";
import BrandLogo from "./BrandLogo";

export default function StaffBrand({ onNavigate }) {
  const { logos } = useBrand();
  const logo = logos?.app;
  return <a href="/" className="staff-brand" onClick={onNavigate}>
    <BrandLogo src={logo} />
  </a>;
}
